import { ReportPreview } from './chunk-CS23GKGR.js';
import * as React from 'react';
import { formatTimestamp } from '@authe/fe-commons/time';
import { Button, notifyError } from '@authe/ui-core';
import { jsx } from 'react/jsx-runtime';

function ReportDownloadButton({ report }) {
  const [busy, setBusy] = React.useState(false);
  const download = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const { exportReportPdf } = await import('./reportToPdf-K2AEIJ6T.js');
      await exportReportPdf(report);
    } catch (error) {
      notifyError(error, { title: "Could not download report" });
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", disabled: busy, onClick: () => void download(), children: busy ? "Preparing PDF\u2026" : "Download PDF" });
}
function stampedSnapshot(snapshot) {
  const report = snapshot.report;
  const saved = snapshot.frozenAt ? `${formatTimestamp(snapshot.frozenAt, { unit: "milliseconds", timeZone: "UTC" })} UTC` : "Unknown";
  return {
    ...report,
    kicker: report.kicker ? `${report.kicker} \xB7 saved copy` : "Saved report",
    meta: [{ label: "Saved", value: saved }, ...(report.meta ?? []).filter((m) => m.label !== "Saved")]
  };
}
function ReportSnapshotView({ snapshot, className, actions, renderers }) {
  const report = React.useMemo(() => stampedSnapshot(snapshot), [snapshot]);
  return /* @__PURE__ */ jsx(ReportPreview, { report, className, actions: actions ?? /* @__PURE__ */ jsx(ReportDownloadButton, { report }), renderers });
}

export { ReportDownloadButton, ReportSnapshotView, stampedSnapshot };
//# sourceMappingURL=chunk-XFOQOBAW.js.map
//# sourceMappingURL=chunk-XFOQOBAW.js.map